import { __decorate } from "tslib";
import { AsnProp, AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
import { LogotypeData } from "./logotype_data";
import { LogotypeReference } from "./logotype_reference";
let LogotypeInfo = class LogotypeInfo {
    constructor(params = {}) {
        Object.assign(this, params);
    }
};
__decorate([
    AsnProp({ type: LogotypeData, implicit: true, context: 0 })
], LogotypeInfo.prototype, "direct", void 0);
__decorate([
    AsnProp({ type: LogotypeReference, implicit: true, context: 1 })
], LogotypeInfo.prototype, "indirect", void 0);
LogotypeInfo = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], LogotypeInfo);
export { LogotypeInfo };
